<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 5H20.0002V7H4V5ZM4 17H20.0002V19H4V17ZM20.0002 11.0001H4V13.0001H20.0002V11.0001Z"
    />
  </svg>
</template>
